export default __webpack_public_path__ + "static/media/ESTO.f89d6e29.jpg";